import {useMemo} from "react";

export enum Platform {
    VEGAS,
    WINNING_PARTNER,
    UNKNOWN
}

function usePlatform() {
    const hostname = window.location.hostname.toLowerCase();

    return useMemo(() => {
        let platform = Platform.UNKNOWN;
        if (hostname.includes("vegas")) platform = Platform.VEGAS;
        if (hostname.includes("winningpartner")) platform = Platform.WINNING_PARTNER;

        return {
            isVegas: () => platform === Platform.VEGAS,
            isWinningPartner: () => platform === Platform.WINNING_PARTNER,
            platform: () => platform
        };
    }, [hostname]);
}

export default usePlatform;